import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "0",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_RefDt: new Date(), // dd/MM/yyyy
    A_RefNo: "",
    A_Party: "",
    A_PartyName: "",
    A_Type: "",
    A_Loc: "",
    A_LocName: "",
    A_DocStat: "ENTER",
    UnloadingBay: "", // Unloading Bin ID
    UnloadingBayName: "", // Unloading Bin Name
    Cluster: "",
    Transaction: "",
    Truck: "",
    Driver: "",
    DriverName: "",
    TruckCBM: "",
    ItemCBM: 0,
    TotalWeight: 0,
    
  },
  LoadingListUser:[],
  LoadingListUserCheckbox: [
    {
      UId: "",
      Name1: " ",
      Flag: "N",
    },
  ],
};

const SliceLoadingList = createSlice({
  name: "SliceLoadingList",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_LoadingList_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_LoadingList_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },
    Set_LoadingList_HeadLoadingListUserCheckbox_Init: (state) => {
      state.value.LoadingListUserCheckbox =
        initialState.LoadingListUserCheckbox;
    },

    Set_LoadingList_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_LoadingList_HeadLoadingListUserCheckbox: (state, action) => {
      state.value.LoadingListUserCheckbox = action.payload;
    },
    Set_LoadingList_HeadLoadingListUser: (state, action) => {
      state.value.LoadingListUser = action.payload;
    },

    Wms_LoadingList_HeadObject_New_Set: (state, action) => {
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocTypName = action.payload.A_VocTypName;
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.Cluster = action.payload.Cluster;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.Transaction = action.payload.Transaction;
      state.value.HeadObject.UnloadingBay = action.payload.UnloadingBay;
      state.value.HeadObject.Truck = action.payload.Truck;
      state.value.HeadObject.A_Type = action.payload.A_Type;
      state.value.HeadObject.A_Party = action.payload.A_Party;
      state.value.HeadObject.A_PartyName = action.payload.A_PartyName;
    },
    Wms_LoadingList_Footer_CBM: (state, action) => {
      state.value.HeadObject.ItemCBM = action.payload.ItemCBM;
      state.value.HeadObject.TotalWeight = action.payload.TotalWeight;
    },

    Set_LoadingList_HeadObject_A_VocNo: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },

    Set_LoadingList_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
  },
});

export const {
  Set_LoadingList_Init,
  Set_LoadingList_HeadObject_Init,
  Set_LoadingList_HeadObject_Set,
  Wms_LoadingList_HeadObject_New_Set,
  Set_LoadingList_HeadObject_A_VocNo,
  Set_LoadingList_HeadObject_A_DocStat,
  Wms_LoadingList_Footer_CBM,
  Set_LoadingList_HeadLoadingListUserCheckbox,
  Set_LoadingList_HeadLoadingListUser
} = SliceLoadingList.actions;
export default SliceLoadingList.reducer;
